// extracted by mini-css-extract-plugin
export var container = "_mq-0";
export var dotAnimation = "_mq-2";
export var dotsLoading = "_mq-1";